import { IStyle, mergeStyleSets } from "@fluentui/react";

export const customerInfoStyles = mergeStyleSets({
  container: {
    flex: 1,
    paddingLeft: 7,
    paddingRight: 7
  } as IStyle,
  shimmer: {
    marginTop: 10
  } as IStyle,
  shimmer35: {
    marginTop: 10,
    width: "35%"
  } as IStyle,
  shimmer90: {
    marginTop: 10,
    width: "90%"
  } as IStyle,
  shimmer95: {
    marginTop: 10,
    width: "95%"
  } as IStyle,
  header: {
    display: "flex",
    margin: 0,
    marginBottom: 10
  } as IStyle,
  poweredBy: {
    paddingLeft: 10
  } as IStyle,
  description: {
    "@media (max-width: 1200px)": {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      overflowY: "auto",
      maxHeight: 148,
      lineHeight: 20
    }
  } as IStyle
});
